<div class="module-cards-container text-center">
	<div class="row module-cards-grid">
		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					height="120px"
					src="../../assets/img/team/anil.svg"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="regscale-works-card-inner module-cards-linear-gradient3"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="regscale-works-card module-cards-linear-gradient3"
								>Anil Karmel
							</strong>
							<p class="mt-2">CEO / CO-FOUNDER</p>
							<p class="mt-4">
								Anil Karmel serves as the co-founder and CEO of
								RegScale designed to bring the principles of
								DevOps to Compliance (Regulatory Operations:
								RegOps). Formerly, Anil served as the National
								Nuclear Security Administration's (NNSA) Deputy
								Chief Technology Officer. Karmel began his
								government career as a Technical Staff Member of
								Los Alamos National Laboratory (LANL) and was
								responsible for inventing their cloud and
								collaboration technologies
								<span
									*ngIf="!showMore1"
									(click)="toggleMore1()"
									class="moreBtn1"
									>...more
								</span>

								<span *ngIf="showMore1" id="more1"
									>Karmel and his team have garnered industry
									and government accolades, including the SANS
									National Cyber Security Innovators Award for
									Cloud Security, InformationWeek 500 Top
									Government IT Innovators, ACT/IAC
									Excellence.gov Award and the DOE Secretary's
									Achievement Award. Anil currently serves as
									the president of the Cloud Security
									Alliance’s DC Metro Area Chapter and as a
									member of the CSA's CxO Trust Advisory
									Council.
									<span
										*ngIf="showMore1"
										class="moreBtn3"
										(click)="showLess1()"
										>...less</span
									>
								</span>
							</p>
						</div>
						<a
							target="_blank"
							href="https://www.linkedin.com/in/anilkarmel/"
						>
							<img
								class="mt-4"
								src="../../assets/img/linkedin-blue.svg"
								alt=""
							/>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-6 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					height="120px"
					src="../../assets/img/team/travis.svg"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="regscale-works-card-inner module-cards-linear-gradient2"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="regscale-works-card module-cards-linear-gradient2"
								>Travis Howerton
							</strong>
							<p class="mt-2">CTO / CO-FOUNDER</p>
							<p class="mt-4">
								After executive leadership roles in some of the
								largest public and private sector IT
								organizations in the United States (to include
								the National Nuclear Security Administration
								(NNSA), Oak Ridge National Laboratory (ORNL),
								and Bechtel), Howerton joined RegScale to drive
								product development and corporate strategy. With
								over 20 years delivering "no fail" missions, he
								is a trusted advisor of our largest clients,
								thought leader for our product strategy, and
								focused on delivering
								<span
									*ngIf="!showMore2"
									class="moreBtn2"
									(click)="toggleMore2()"
									>...more</span
								>
								<span *ngIf="showMore2" id="more2">
									sustainable long-term growth for the
									company. Travis is a serial innovator having
									won the Fed 100 Award, the ACT-IAC Award for
									Most Innovative Project in Government,
									maintains multiple certifications including
									his PMP, ITIL, CISSP, and Harvard Credential
									of Readiness, and graduated with a Master's
									of Science in Computer Information Systems
									from Boston University.

									<span
										*ngIf="showMore2"
										class="moreBtn3"
										(click)="showLess2()"
										>...less</span
									>
								</span>
							</p>
						</div>
						<a
							href="https://www.linkedin.com/in/travishowerton/"
							target="_blank"
						>
							<img
								class="mt-4"
								src="../../assets/img/linkedin-blue.svg"
								alt=""
						/></a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-12 mb-5">
			<div class="regscale-works-card-bottom">
				<img
					width="120px"
					height="120px"
					src="../../assets/img/team/robbie.svg"
					alt=""
				/>
			</div>
			<div class="regscale-works-card-outer px-3 pt-2 pb-3">
				<div
					class="regscale-works-card-inner module-cards-linear-gradient3"
				>
					<div
						class="regscale-works-content px-3 px-xl-4 text-center"
					>
						<div>
							<strong
								class="regscale-works-card module-cards-linear-gradient3"
								>Robbie Robbins
							</strong>
							<p class="mt-2">VP of Sales</p>
							<p class="mt-4">
								Robbie Robbins brings to RegScale over 30 years of experience in Cyber Security, Information Risk Management, IT Compliance, Identity Management, Encryption, and IoT/IIOT vulnerability markets. 

								Prior to joining RegScale, he helped launch ReFirm Labs which was recently acquired by Microsoft.  Robbie has held direct sales, business development, and leadership roles at companies including Digital Equipment, Symantec, PGP, Raytheon, and Threat Connect.
								<span
									*ngIf="!showMore3"
									class="moreBtn3"
									(click)="toggleMore3()"
									>...more</span
								>
								<span *ngIf="showMore3" id="more3">
									Robbie earned a BA in Management and Entrepreneurship from Saint Mary’s College of California while working full time as an Enterprise Sales Executive. 

								In his spare time, he enjoys traveling the globe and is an avid water polo player.

									<span
										*ngIf="showMore3"
										class="moreBtn3"
										(click)="showLess3()"
										>...less</span
									>
								</span>
							</p>
						</div>
						<a
							target="_blank"
							href="https://www.linkedin.com/in/robbierobbins/"
						>
							<img
								class="mt-4"
								src="../../assets/img/linkedin-blue.svg"
								alt=""
							/>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
